import { DriverLicenseAndIdFormTypes } from "./DriverLicenseAndIdForm";

export const formMapper = (formData: DriverLicenseAndIdFormTypes): Omit<MyBrokerApi.PersonalDetails, "lastName"> => {
    return {
        identityCard: {
            nationalNumber: formData.nationalNumber,
            number: formData.cardNumber,
            validTo: formData?.validTo,
            validFrom: formData?.validFrom,
            issuedBy: formData.issuedBy,
        },
        driversLicense: {
            number: formData.number,
            issueDate: formData?.issueDate,
            type: { id: formData.type },
            issueCountry: { id: formData.issueCountry },
        },
    };
};
